import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHeaderTitle } from "stores/slices/layout";

import BroadcastListTable from "components/broadcastList/broadcastListTable";

const BroadcastList = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle(["customer", "broadcastList"]));
  }, []);
  return (
    <div>
      <BroadcastListTable />
    </div>
  );
};

export default BroadcastList;
